import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { PayUnpaidInstallmentsResponse, ReceiptsPaginableRequestInterface, ResolvedStepInterface, StepInterface } from 'sp-arch-lib';
import { LocalUnit, LoginData, Merchant, UserInformationInterface } from 'sp-ui-lib';

export const startBoot = createAction(
  '[Boot] Start Boot'
);

export const mandatoryData = createAction(
  '[Boot] Mandatory Data'
);

export const checkSteps = createAction(
  '[Boot] Check Steps',
    props<{ flagCheckInsolventMerchant: boolean }>()
);

export const checkStepsSuccess = createAction(
  '[Boot] Check Steps Success',
  props<{ steps: StepInterface[] }>()
);

export const checkStepsFailure = createAction(
  '[Boot] Check Steps Failure'
);

export const setCurrentStepIndex = createAction(
  '[Boot] Set Current Step Index',
  props<{ currentStepIndex: number }>()
);

export const runStep = createAction(
  '[Boot] Run step',
  props<{ step: StepInterface }>()
);

export const resolveStep = createAction(
  '[Boot] Resolve Step',
  props<{ resolvedStep: ResolvedStepInterface }>()
);

export const resolveStepFailure = createAction(
  '[Boot] Resolve Step Failure'
);

export const doLogin = createAction(
  '[Login] Do Login',
  props<{ loginData: LoginData }>()
);

export const loginSuccess = createAction(
  '[Login] Login Success',
  props<{ userInformation: UserInformationInterface }>()
);

export const loginFailure = createAction(
  '[Login] Login Failure',
  props<{ error: HttpErrorResponse }>()
);

export const rememberMe = createAction(
  '[Login] Remember Me',
  props<{ username: string }>()
);

export const forgetMe = createAction(
  '[Login] Forget Me'
);

export const retrieveLocalUnits = createAction(
  '[Boot] Retrieve LocalUnits',
);

export const retrieveLocalUnitsSuccess = createAction(
  '[Boot] Retrieve LocalUnits Success',
  props<{ localUnits: Array<LocalUnit> }>()
);

export const retrieveLocalUnitsFailure = createAction(
  '[Boot] Retrieve LocalUnits Failure'
);

export const toggleLocalUnit = createAction(
  '[Boot] Toggle LocalUnit',
  props<{ localUnit: LocalUnit }>()
);

export const toggleLocalUnitById = createAction(
  '[Boot] Toggle LocalUnit By Local Unit ID',
  props<{ id: number }>()
);

export const toggleAllLocalUnits = createAction(
  '[Boot] Toggle All LocalUnits'
);

export const retrieveLoggedMerchant = createAction(
  '[Boot] Retrieve Logged Merchant'
);

export const retrieveLoggedMerchantSuccess = createAction(
  '[Boot] Retrieve Logged Merchant Success',
  props<{ merchant: Merchant }>()
);

export const retrieveLoggedMerchantFailure = createAction(
  '[Boot] Retrieve Logged Merchant Failure'
);

export const toggleLocalUnitsDisable = createAction(
  '[Boot] Set Local Units Menu Disable State',
  props<{ flagLocalUnitsDisabled: boolean }>()
);

export const toggleLocalUnitsCompletlyDisable = createAction(
  '[Boot] Set Local Units Menu Complete Disable State',
  props<{ flagLocalUnitsCompletlyDisabled: boolean }>()
);

export const proceedToPayUnpaidInstallments = createAction(
  '[Boot] Proceed To Pay Unpaid Installments',
  props<{ totalInsolventPayments: number, payments: Array<{ id: number }>; filters: ReceiptsPaginableRequestInterface }>()
);

export const proceedToPayUnpaidInstallmentsSuccess = createAction(
  '[Boot] Proceed To Pay Unpaid Installments Success',
  props<{ response: PayUnpaidInstallmentsResponse; filters: ReceiptsPaginableRequestInterface, totalInsolventPayments: number }>()
);

export const proceedToPayUnpaidInstallmentsFailure = createAction(
  '[Boot] Proceed To Pay Unpaid Installments Failure',
  props<{ errorDescription: string }>()
);
